import { useDispatch } from "react-redux";
import { BLUR_INTENSITY_MIN_VALUE, FOV_MAX_VALUE, FOV_MIN_VALUE } from "../../../../../config/constant/projectConstant";
import { infoToast, successToast } from "../../../../../helpers/toastHelper";
import { setGlobalFov } from "../../../../../redux/slicers/camera/cameraSettings";
import { useUnityContext } from "../../../../container/unityContainer";

export const useUnityCameraFields = () => {
  const dispatch = useDispatch();
  const { cameraModule } = useUnityContext();

  const handlePropertyChange = ({ name, value, checked, waitForEscEvent, numberValue }) => {
    switch (name) {
      case 'isdepthOfField':
        cameraModule.OnSelectDepthOfFieldReceiver(checked);
        if (!checked) {
          cameraModule.OnUpdateDepthOfFieldValueReceiver(BLUR_INTENSITY_MIN_VALUE);
        } else {
          // TODO: replace it with info toast
          infoToast('Please select an object');
          waitForEscEvent();
        }
        break;
      case 'isCameraCorrection':
        cameraModule.OnCameraVerticalTiltReceiver(checked);
        break;
      case 'cameraHeight': {
        const height = parseFloat(value);
        if (!Number.isNaN(height)) {
          cameraModule.UpdateCameraHeightReceiver(height);
        }
        break;
      }
      case 'fov': {
        let fov = numberValue;
        if (!Number.isNaN(fov)) {
          fov = fov > FOV_MAX_VALUE ? FOV_MAX_VALUE : fov < FOV_MIN_VALUE ? FOV_MIN_VALUE : fov;
          dispatch(setGlobalFov(fov));
          cameraModule.OnUpdateCameraFovReceiver(fov);
        }
        break;
      }
      case 'blurIntensity': {
        const intensity = parseFloat(value);
        if (!Number.isNaN(intensity)) {
          cameraModule.OnUpdateDepthOfFieldValueReceiver(intensity);
        }
        break;
      }

      default:
    }
  }

  const closeFocusReceiver = () => {
    cameraModule.CloseFocusObjectReceiver()
  }

  const clearSelectedObject = () => {
    cameraModule.ClearSelectedObjectReceiver();
  }

  return {
    handlePropertyChange,
    closeFocusReceiver,
    clearSelectedObject,
  }
}